import React from 'react'
import Fluid from './Fluid'
import { motion } from 'framer-motion'

const PageHero = ({ eyebrow, title, description, children }) => {
  return (
    <section className='page-hero'>
      <div className='aurora' aria-hidden='true'>
        <span className='aurora__blob aurora__blob--1' />
        <span className='aurora__blob aurora__blob--2' />
      </div>
      <Fluid />
      <div className='container-wide page-hero__inner'>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          {eyebrow && <div className='eyebrow eyebrow--light'>{eyebrow}</div>}
          <h1 className='page-hero__title'>{title}</h1>
          {description && <p className='page-hero__desc'>{description}</p>}
          {children}
        </motion.div>
      </div>
    </section>
  )
}

export default PageHero
